export const T = {
  de: {
    nav_title: "Seelenpartner-Tarot",
    hero_overline: "Reine Liebeslegung",
    hero_title: "Seelenpartner-Tarot",
    hero_sub: "Eine warmherzige, intuitive Legung für Seelenpartnerschaften, Dualseelen, karmische Verbindungen und Herzthemen.",
    start_btn: "Seelenpartner-Tarot-Legung starten",
    hero_note: "Alles wird ausschließlich auf die Liebesebene gedeutet.",
    form_title: "Erzähl mir von eurer Verbindung",
    form_sub: "Deine Angaben fließen behutsam in die Deutung ein.",
    your_name: "Dein Vorname",
    your_name_ph: "z. B. Anna",
    partner_name: "Vorname der anderen Person",
    partner_name_ph: "z. B. Lukas",
    your_birth: "Dein Geburtsdatum",
    partner_birth: "Geburtsdatum der anderen Person",
    birth_optional: "(optional, für astrologische Aspekte)",
    question: "Deine Frage oder Situation",
    question_ph: "Was möchtest du über eure Seelenverbindung erfahren?",
    continue_btn: "Weiter zum Kartenlegen",
    draw_title: "Ziehe deine 9 Karten",
    draw_sub: "Atme tief durch, denke an eure Verbindung und wähle mit dem Herzen.",
    draw_progress: (n) => `${n} von 9 Karten gezogen`,
    drawn_label: "Gezogen",
    reveal_btn: "Deutung enthüllen",
    next_pos: "Nächste Karte",
    loading_title: "Deine Seelenlegung wird gedeutet…",
    loading_sub: "Die Energien zwischen euch werden gelesen. Einen Moment der Stille.",
    result_for: "Legung für",
    and: "&",
    section1: "Die Karten & ihre Deutung",
    section2: "Liebe & Seelenpartnerschaft",
    section3: "Blockaden & Chakren",
    section4: "Abschließende Zusammenfassung",
    classic: "Klassische Bedeutung",
    soulmate: "Für eure Seelenpartnerschaft",
    partner_feelings: "Gefühle der anderen Person",
    development: "Entwicklung der Verbindung",
    blockage: "Blockade / Lernaufgabe",
    love_feels: "Was fühlt er/sie wirklich?",
    love_blocks: "Was blockiert die Verbindung?",
    love_chances: "Welche Chancen hat diese Seelenpartnerschaft?",
    love_understand: "Was darfst du jetzt verstehen?",
    chakra_heart: "Herzchakra",
    chakra_solar: "Solarplexus",
    chakra_third: "Stirnchakra",
    chakra_root: "Wurzelchakra",
    chakra_blockage: "Wo die Blockade liegt",
    chakra_influence: "Einfluss auf die Verbindung",
    chakra_healing: "Schritt zur Heilung",
    sum_message: "Wichtigste Botschaft",
    sum_core: "Kernaussage der Legung",
    sum_release: "Was du loslassen darfst",
    sum_invite: "Was du einladen darfst",
    sum_next: "Dein nächster innerer Schritt",
    download_btn: "Legung herunterladen",
    new_btn: "Neue Legung",
    err: "Die Deutung konnte nicht erstellt werden. Bitte versuche es erneut.",
    pos_label: "Position",
  },
  en: {
    nav_title: "Soulmate Tarot",
    hero_overline: "Pure Love Reading",
    hero_title: "Soulmate Tarot",
    hero_sub: "A warm-hearted, intuitive reading for soulmates, twin flames, karmic connections and matters of the heart.",
    start_btn: "Start Soulmate Tarot Reading",
    hero_note: "Everything is interpreted exclusively on the love level.",
    form_title: "Tell me about your connection",
    form_sub: "Your details gently flow into the reading.",
    your_name: "Your first name",
    your_name_ph: "e.g. Anna",
    partner_name: "The other person's first name",
    partner_name_ph: "e.g. Lukas",
    your_birth: "Your birth date",
    partner_birth: "The other person's birth date",
    birth_optional: "(optional, for astrological aspects)",
    question: "Your question or situation",
    question_ph: "What would you like to know about your soul connection?",
    continue_btn: "Continue to draw cards",
    draw_title: "Draw your 9 cards",
    draw_sub: "Breathe deeply, think of your connection and choose with your heart.",
    draw_progress: (n) => `${n} of 9 cards drawn`,
    drawn_label: "Drawn",
    reveal_btn: "Reveal the reading",
    next_pos: "Next card",
    loading_title: "Your soul reading is being interpreted…",
    loading_sub: "The energies between you are being read. A moment of stillness.",
    result_for: "Reading for",
    and: "&",
    section1: "The Cards & Their Meaning",
    section2: "Love & Soul Partnership",
    section3: "Blockages & Chakras",
    section4: "Final Summary",
    classic: "Classic meaning",
    soulmate: "For your soul partnership",
    partner_feelings: "The other person's feelings",
    development: "Development of the connection",
    blockage: "Blockage / lesson",
    love_feels: "What does he/she really feel?",
    love_blocks: "What blocks the connection?",
    love_chances: "What chances does this soul partnership have?",
    love_understand: "What may you understand now?",
    chakra_heart: "Heart Chakra",
    chakra_solar: "Solar Plexus",
    chakra_third: "Third Eye",
    chakra_root: "Root Chakra",
    chakra_blockage: "Where the blockage sits",
    chakra_influence: "Influence on the connection",
    chakra_healing: "Step toward healing",
    sum_message: "Most important message",
    sum_core: "Core statement of the reading",
    sum_release: "What you may let go of",
    sum_invite: "What you may invite in",
    sum_next: "Your next inner step",
    download_btn: "Download reading",
    new_btn: "New reading",
    err: "The reading could not be created. Please try again.",
    pos_label: "Position",
  },
};
